/*
 * Jira Ticket:
 * Created Date: Wed, 1st Apr 2020, 15:02:53 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getListDashboardQuery = gql`
  query dashboardData {
    data: dashboardData {
      statistics {
        icon
        name
        value
      }
    }
  }
`;

export default ({ client, params }) => {
  try {
    return client.query({
      query: getListDashboardQuery,
      variables: {
        ...params,
      },
      fetchPolicy: 'network-only',
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
